import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  MAX_SESSION_DURATION_MS,
  formatTimeRemaining,
  getTokenExpiration,
  useSessionTimeout,
} from "@p0security/frontend-core";
import {
  Button,
  Flex,
  Modal,
  Space,
  Spacing,
  Typography,
} from "@p0security/ui";
import React, { PropsWithChildren } from "react";
import { colors } from "styles/variables";

const SessionManager: React.FC<PropsWithChildren<object>> = ({ children }) => {
  const tokenExpiration = getTokenExpiration();
  const sessionStart = sessionStorage.getItem("sessionStart");

  const maxSessionDurationMs =
    tokenExpiration && sessionStart
      ? Number(tokenExpiration) - Number(sessionStart)
      : MAX_SESSION_DURATION_MS;

  const { isModalVisible, isSessionWarning, displayTime, closeModal, signOut } =
    useSessionTimeout({
      maxSessionDurationMs,
    });

  return (
    <>
      {children}
      <Modal
        title={
          isSessionWarning
            ? "Session Duration Warning"
            : "Session Inactivity Warning"
        }
        open={isModalVisible}
        onCancel={closeModal}
        footer={false}
        maskClosable={false}
        destroyOnHidden
      >
        <Spacing asChild mb="20px">
          <Typography.Text
            /* eslint-disable-line react/forbid-component-props */ style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <ExclamationCircleOutlined
              /* eslint-disable-line react/forbid-component-props */ style={{
                fontSize: 24,
                color: colors.themeColors.red,
              }}
            />
            <div>
              <Typography.Text>
                For security reasons, your session will automatically end in{" "}
                <Typography.Text strong type="warning">
                  {formatTimeRemaining(displayTime)}
                </Typography.Text>
              </Typography.Text>
              <br />
              <Typography.Text type="secondary">
                {isSessionWarning
                  ? "This is due to reaching the maximum session duration limit."
                  : "This is due to an extended period of inactivity."}
              </Typography.Text>
            </div>
          </Typography.Text>
        </Spacing>
        <Flex className="w-full" justify="flex-end">
          <Space>
            {(!isSessionWarning || !tokenExpiration) && (
              <Button key="extend" type="primary" onClick={closeModal}>
                Stay Logged In
              </Button>
            )}
            <Button key="logout" onClick={signOut}>
              Log Out
            </Button>
          </Space>
        </Flex>
      </Modal>
    </>
  );
};

export default SessionManager;
